const sagaReady = {};

export const markSagaReady = key => {
  sagaReady[key] = true;
};

export const markSagaNotReady = key => {
  sagaReady[key] = false;
};

export const isSagaReady = key => sagaReady[key] === true;

export const waitForSaga = key =>
  new Promise(resolve => {
    const check = () => {
      if (isSagaReady(key)) resolve(true);
      else setTimeout(check, 10);
    };
    check();
  });
